import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { AuthService } from 'AuthService';

@Injectable()
export class SelbstauskunftGuard {
  constructor(private router: Router, private authService: AuthService) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (this.authService.isSelbstauskunftEnabled()) {
      return true;
    }

    this.router.navigate([route.data['extern'] ? '/extern/home' : '/home']);
    return false;
  }
}
